import api from '../../api'

export default function getOffers(brandId) {
  return api.get(`/brands/${brandId}`);
}